import API from "../../../app/api";

export const deleteCartItem = async (cartId) => {
  try {
    const response = await API.delete(
      `/cart/${cartId}`
    );

    return response.data;

  } catch (error) {
    console.error("Delete Cart Error:", error);
    throw error;
  }
};